// @flow
import React from "react";
import { connect } from "react-redux";
import { Translate } from "@quantum/i18n";
import SelectInput from "../../../comum/SelectInput";
import type { Id, Volatilidade } from "../../../../model";
import {
  type ActionCreator,
  selecionarVolatilidade,
  getVolatilidades,
  getVolatilidadeSelecionada,
} from "../../../../state";

type Prop = {
  listaVolatilidade: Array<Volatilidade>,
  volatilidadeSelecionada: Id,
  selecionarVolatilidade: ActionCreator,
};

function SelecaoVolatilidade({
  listaVolatilidade,
  volatilidadeSelecionada,
  selecionarVolatilidade,
}: Prop) {
  function handleVolatilidadeSelecionada(volatilidade) {
    selecionarVolatilidade(volatilidade);
  }

  return (
    <div>
      <Translate className="ConfiguracaoMedida__label--no-margin">
        Volatilidade
      </Translate>
      <SelectInput
        value={volatilidadeSelecionada}
        options={listaVolatilidade}
        onChange={handleVolatilidadeSelecionada}
        multiple={false}
        size={listaVolatilidade.length}
        campoDescricao={"descricao"}
      />
    </div>
  );
}

export default connect(
  state => ({
    listaVolatilidade: getVolatilidades(state),
    volatilidadeSelecionada: getVolatilidadeSelecionada(state),
  }),
  { selecionarVolatilidade }
)(SelecaoVolatilidade);
